import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const LicenseTypeRoutes = [
  {
    path: '/license-types',
    name: 'ListLicenseTypes',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license_type:list'
    }
  },
  {
    path: '/license-type',
    name: 'CreateLicenseType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license_type:create'
    }
  },
  {
    path: '/license-type/:id',
    name: 'UpdateLicenseType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license_type:update'
    }
  },
  {
    path: '/license-type/view/:id',
    name: 'GetLicenseType',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'license_type:get'
    }
  }
]
